/*
 * The message banner (prototype: .bnHost, .banner; ../in-app-notifications/client-notification-banner.html).
 * Colors are theme tokens only.
 */
@layer telify {
  .host {
    position: fixed;
    z-index: 65;
    top: calc(var(--head-h) + 12px);
    right: max(40px, calc((100% - var(--wrap)) / 2));
    width: min(400px, calc(100% - 32px));
    transition: transform 0.26s cubic-bezier(0.32, 0.72, 0, 1), opacity 0.22s ease;
  }

  .out {
    opacity: 0;
    transform: translateY(-24px);
    pointer-events: none;
  }

  .banner {
    appearance: none;
    border: 0;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 11px 14px 11px 11px;
    text-align: left;
    font: inherit;
    color: inherit;
    border-radius: 14px;
    background: var(--glass-bg-strong);
    backdrop-filter: var(--glass-blur);
    box-shadow: var(--glass-shadow);
    animation: bannerIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  }

  .banner::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    pointer-events: none;
    z-index: 2;
    background: linear-gradient(135deg, rgba(var(--accent-light-rgb), 0.16) 0%, rgba(var(--accent-light-rgb), 0.03) 100%);
    -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  .banner > * {
    position: relative;
    z-index: 1;
  }

  @keyframes bannerIn {
    from {
      opacity: 0;
      transform: translateY(-24px) scale(0.98);
    }
  }

  .logo {
    flex-shrink: 0;
    display: block;
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  .noMark {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: rgba(var(--accent-rgb), 0.14);
    color: var(--accent);
  }

  .info {
    flex: 1;
    min-width: 0;
  }

  .title {
    display: block;
    font-family: var(--font-display);
    font-size: 17px;
    font-weight: 500;
    line-height: 1.15;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .detail {
    display: block;
    font-size: 13px;
    color: var(--text-secondary);
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .aside {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    flex-shrink: 0;
  }

  .time {
    font-size: 10.5px;
    font-weight: 500;
    color: var(--text-tertiary);
  }

  .chev {
    width: 14px;
    height: 14px;
    color: var(--chevron-color);
    stroke-width: 2.4;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  /* Queue hint: two faint stacked edges under the card; the next banner slides in when this one goes. */
  .queued::after,
  .queued::before {
    content: '';
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: -5px;
    height: 10px;
    border-radius: 0 0 14px 14px;
    background: var(--glass-bg-strong);
    border: 1px solid var(--glass-border-strong);
    border-top: 0;
    z-index: -1;
  }

  .queued::before {
    left: 22px;
    right: 22px;
    bottom: -10px;
    opacity: 0.55;
  }

  @media (prefers-reduced-motion: reduce) {
    .host {
      transition: opacity 0.22s ease;
    }

    .out {
      transform: none;
    }

    .banner {
      animation: none;
    }
  }

  /* web-studio-sites D12: under a custom site's header the banner sits at her page's edge, never less than 16 pixels
     in (telify-pages.html .bnHost). */
  :global(:root[data-custom-site]) .host {
    right: max(16px, calc((100% - var(--wrap)) / 2));
  }
}
